import {
  SET_IDXDB_VALIDATIONS,
  UPDATE_SUCCESS_VALIDATIONS,
  UPDATE_ERROR_VALIDATIONS,
  SET_IDXDB_LOADING,
  LOAD_VALIDATIONS_ERROR,
  LOAD_VALIDATIONS_SUCCESS,
  SET_IDXDB_ERROR,
} from "../actions/actionTypes";

export default function validationReducer(
  state = {
    validations: {},
    timestamp: {},
    loading: true,
    updating: false,
    error: {},
  },
  action
) {
  switch (action.type) {
    case SET_IDXDB_LOADING:
      state.loading = true;
      return { ...state };
    case SET_IDXDB_VALIDATIONS:
      state.loading = false;
      state.updating = true;
      return { ...state };
    case UPDATE_SUCCESS_VALIDATIONS:
      state.validations = action.validationPayload;
      state.timestamp = action.validationPayload.timestamp;
      state.updating = false;
      state.loading = false;
      return { ...state };
    case LOAD_VALIDATIONS_SUCCESS:
      state.validations = action.validationPayload;
      state.timestamp = action.validationPayload.timestamp;
      state.loading = false;
      return { ...state };
    case UPDATE_ERROR_VALIDATIONS:
      state.error = action.payload;
      state.updating = false;
      state.loading = false;
      return { ...state };
    case LOAD_VALIDATIONS_ERROR:
      state.error = action.payload;
      state.loading = false;
      return { ...state };
    case SET_IDXDB_ERROR:
      state.error = action.error;
      state.loading = false;
      state.updating = false;
      return { ...state };
    default:
      return state;
  }
}
